angular
    .module('app')
    .component('dashboard', {
        templateUrl: '/templates/pages/dashboard/dashboard.html',
        controller: 'DashboardController',
        controllerAs: 'vm',
    });